import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import {
  Button,
  DatePicker,
  Drawer,
  Dropdown,
  Input,
  Layout,
  Menu,
  message,
  Modal,
  Select,
  Table,
  Tooltip,
  Form,
  Tag,
} from "antd";
import { Link, useNavigate, useLocation } from "react-router-dom";
// @ts-ignore
import "../MasterLayout/Master.css";
import { BiCoinStack } from "react-icons/bi";
import {
  DashboardOutlined,
  ProjectOutlined,
  UserOutlined,
  SolutionOutlined,
  CalendarOutlined,
  AppstoreAddOutlined,
  CheckSquareOutlined,
  ClockCircleOutlined,
  ScheduleOutlined,
  LaptopOutlined,
  SafetyOutlined,
  CarryOutOutlined,
  MacCommandOutlined,
  FileTextOutlined,
  ProfileOutlined,
  CompassOutlined,
  ContactsOutlined,
  CodeSandboxOutlined,
  LikeOutlined,
  LineChartOutlined,
  SettingOutlined,
  RobotOutlined,
  FundOutlined,
  CodepenOutlined,
  FileOutlined,
  TagOutlined,
  DatabaseOutlined,
  TeamOutlined,
  WalletOutlined,
  MailOutlined,
  BellOutlined,
  CopyOutlined,
  CheckOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { MdBuild, MdCurrencyRupee } from "react-icons/md";
import { AuthContext } from "../Auth/AuthContext";
import { getErrorMessage } from "../utils/getErrorMessage";
import {
  addFilter,
  deleteFilter,
  getallDeveloperForTask,
  getAllSources,
  getAllTags,
  getFilter,
  getLeadStatus,
  GetSettingData,
  updateFilter,
} from "../utils/API";
import { useSettings } from "../Pages/Settings/SettingContext";
import { Key, LucideFileUser } from "lucide-react";
import countries from "../utils/country.json";
import * as Icons from "@ant-design/icons";
import dayjs, { Dayjs } from "dayjs";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { IoReceiptOutline } from "react-icons/io5";
import { link } from "fs";
import { useNotifications } from "../Context/NotificationContext";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { BsClockHistory } from "react-icons/bs";
import { RiFileCopyLine, RiCheckLine } from "react-icons/ri";

const { Sider } = Layout;
const { SubMenu } = Menu;
const { Option } = Select;

interface SidebarProps {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  onCollapse: (collapsed: boolean) => void;
  isSmallScreen: boolean;
  disableHover: boolean;
  onItemClick: () => void;
  hoverEffectActive: boolean;
  setHoverEffectActive: (val: boolean) => void;
  forceCollapse: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({
  collapsed,
  setCollapsed,
  onCollapse,
  isSmallScreen,
  disableHover,
  onItemClick,
}) => {
  const Logo_Main = require("../Assets/logo.png");
  const navigate = useNavigate();
  const location = useLocation();
  const [isHovering, setIsHovering] = useState(false);
  const [activeMenuItemKey, setActiveMenuItemKey] = useState<string | null>(
    null,
  );
  const { settings, updateSettings } = useSettings();
  const [logo, setLogo] = useState<string | null>(null);
  const settingImageUrl = `${process.env.REACT_APP_IMAGE_URL}/settings`;
  const [hoverEffectActive, setHoverEffectActive] = useState(true);
  const [openKeys, setOpenKeys] = useState<string[]>(() => {
    const saved = localStorage.getItem("sidebarOpenKeys");
    return saved ? JSON.parse(saved) : [];
  });
  const { authData } = useContext(AuthContext);
  const isAdmin = authData?.roleId?.roleId === 1;
  const isDeveloper = authData?.roleId?.roleId === 2;
  const userId = authData?.user?._id;

  const [profileMenuOpen, setProfileMenuOpen] = useState(false);

  // Close profile menu when clicking outside
  useEffect(() => {
    if (!profileMenuOpen) return;
    const handler = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target.closest(".profile-footer-area")) {
        setProfileMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [profileMenuOpen]);

  const handleLogout = () => {
    localStorage.removeItem("authData");
    localStorage.removeItem("token");
    localStorage.removeItem("favouriteFilters");
    navigate("/login");
  };
  const [hoverTimeout, setHoverTimeout] = useState<NodeJS.Timeout | null>(null);
  const siderRef = useRef<HTMLDivElement>(null);

  const [isCrmSettingsOpen, setIsCrmSettingsOpen] = useState(false);
  const [platform, setPlatform] = useState([]);
  const [developers, setDevelopers] = useState([]);
  const [sources, setSources] = useState<Array<string>>([]);
  const [statuses, setStatuses] = useState<any>([]);
  const [tags, setTags] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [timeFilter, setTimeFilter] = useState<
    "today" | "thisMonth" | "lastMonth" | "custom" | undefined
  >(undefined);
  const [followuptimeFilter, setfollowupTimeFilter] = useState<
    | "followupToday"
    | "followupThisMonth"
    | "followupLastMonth"
    | "followupCustom"
    | undefined
  >(undefined);
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [followupstartDate, setfollowupStartDate] = useState<Dayjs | null>(
    null,
  );
  const [followupendDate, setfollowupEndDate] = useState<Dayjs | null>(null);
  const [tempStartDate, setTempStartDate] = useState<Dayjs | null>(null);
  const [tempEndDate, setTempEndDate] = useState<Dayjs | null>(null);
  const [followuptempStartDate, setfollowupTempStartDate] =
    useState<Dayjs | null>(null);
  const [followuptempEndDate, setfollowupTempEndDate] = useState<Dayjs | null>(
    null,
  );
  const [showRangePicker, setShowRangePicker] = useState(false);
  const [followupshowRangePicker, setfollowupShowRangePicker] = useState(false);
  const [statusFilter, setStatusFilter] = useState<string[]>([]); // multiple select
  // --- state ---
  const [selectedSource, setSelectedSource] = useState<string[] | null>(null);
  const [selectedPlatform, setSelectedPlatform] = useState<string[] | null>(
    null,
  );
  const [selectedPriority, setSelectedPriority] = useState<string | null>(null);
  const [selectedCountry, setSelectedCountry] = useState<string | null>(null);
  const [selectedStatus, setSelectedStatus] = useState<string[] | null>(null);
  const [selectedOwner, setSelectedOwner] = useState<string[] | null>(null);
  const [selectedAssignee, setSelectedAssignee] = useState();
  const [selectedTags, setSelectedTags] = useState<string[] | null>(null);
  const currentPathWithQuery = useMemo(
    () => location.pathname + location.search,
    [location.pathname, location.search],
  );
  const queryParams = new URLSearchParams(location.search);
  const slug = queryParams.get("slug");
  const [error, setError] = useState("");
  const [copiedId, setCopiedId] = useState<string | null>(null);
  const [selectedKeys, setSelectedKeys] = useState<string[]>(() => {
    return JSON.parse(localStorage.getItem("crmSelectedKeys") || "[]");
  });

  const priorityColors: Record<string, string> = {
    High: "#e6533c",
    Medium: "#23b7e5",
    Low: "#26bf94",
  };

  const { fetchNotifications } = useNotifications();

  const handleCrmMenuClick = (key: string) => {
    setSelectedKeys([key]);
    localStorage.setItem("crmSelectedKeys", JSON.stringify([key]));
  };

  const slugify = (text: string) =>
    text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(/[^\w\-]+/g, "") // Remove special chars
      .replace(/\-\-+/g, "-"); // Replace multiple - with single -

  const applyFavouriteFilter = (fav: any) => {
    const params = new URLSearchParams();

    if (fav.source?.length) params.set("source", fav.source.join(","));
    if (fav.sourceid?.length) params.set("sourceid", fav.sourceid.join(","));
    if (fav.priority?.length) params.set("priority", fav.priority.join(","));
    if (fav.country?.length) params.set("country", fav.country.join(","));
    if (fav.status?.length) params.set("status", fav.status.join(","));
    if (fav.owner?.length) params.set("owner", fav.owner.join(","));
    if (fav.assignees) params.set("Assignee", fav.assignees);
    if (fav.tags?.length) params.set("tags", fav.tags.join(","));
    if (fav.time) params.set("time", fav.time);
    if (fav.startDate) params.set("startDate", fav.startDate);
    if (fav.endDate) params.set("endDate", fav.endDate);
    if (fav.followupdate) params.set("followupdate", fav.followupdate);
    if (fav.followupstartDate)
      params.set("followupstartDate", fav.followupstartDate);
    if (fav.followupendDate) params.set("followupendDate", fav.followupendDate);

    const slug = slugify(fav.name);

    navigate(`/rawdata?slug=${slug}&${params.toString()}`);
  };

  const fetchStatuses = async () => {
    try {
      // 🛑 condition: skip if developer
      if (isDeveloper) {
        return;
      }

      const response = await getLeadStatus();
      setStatuses(response.data);
    } catch (error) {
      console.error("Error fetching statuses:", error);
      message.error("Failed to fetch statuses.");
    }
  };

  const fetchDevelopers = async (userId: any, isAdmin: boolean) => {
    try {
      const res = await getallDeveloperForTask("", "");
      if (res.data) {
        if (isAdmin) {
          // Admin → show all owners
          const owners = res.data.filter((dev: any) => dev.isOwner === true);
          setDevelopers(owners);
        } else {
          // Normal user → show only their own name
          const self = res.data.filter((dev: any) => dev._id === userId._id);
          setDevelopers(self);
        }

        const platform = res.data.filter((dev: any) => dev.isPlatform === true);
        setPlatform(platform);
      }
    } catch (err) {
      console.error("Error fetching developers:", err);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchDevelopers(userId, isAdmin);
    }
  }, [userId, isAdmin]);

  const fetchSource = async () => {
    try {
      const getSource = await getAllSources("", page);
      if (getSource) {
        let filteredSource = getSource.sources.filter((item: any) =>
          item.category.includes("Sales"),
        );
        setSources(filteredSource);
      }
    } catch (error) {
      console.error("Error fetching source:", error);
    }
  };

  const fetchTags = async () => {
    if (isDeveloper) {
      return;
    }
    try {
      const getTags = await getAllTags();
      if (getTags) {
        let filteredTags = getTags.tags.filter((item: any) =>
          item.category.includes("Sales"),
        );
        setTags(filteredTags);
      }
    } catch (error) {
      console.error("Error fetching source:", error);
    }
  };

  useEffect(() => {
    fetchSource();
    fetchStatuses();
    fetchTags();
  }, [authData]);

  const timeFilterOptions = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "last7days", label: "Last 7 Days" },
    { value: "thisMonth", label: "This Month" },
    { value: "lastMonth", label: "Last Month" },
    { value: "Last3Month", label: "Last 3 Month" },
    { value: "Last6Month", label: "Last 6 Month" },
    ...(startDate && endDate
      ? [
          {
            value: "custom",
            label: `${startDate.format("MMM D")} - ${endDate.format("MMM D")}`,
            startDate: startDate.format("DD-MM-YYYY"),
            endDate: endDate.format("DD-MM-YYYY"),
          },
        ]
      : [
          {
            value: "custom",
            label: "Custom Range",
            startDate: null,
            endDate: null,
          },
        ]),
  ];
  const followupFilterOptions = [
    { value: "followupToday", label: "Today" },
    { value: "followupYesterday", label: "Yesterday" },
    { value: "followupLast7Days", label: "Last 7 Days" },
    { value: "followupThisMonth", label: "This Month" },
    { value: "followupLastMonth", label: "Last Month" },
    { value: "followupLast3Month", label: "Last 3 Month" },
    { value: "followupLast6Month", label: "Last 6 Month" },

    ...(followupstartDate && followupendDate
      ? [
          {
            value: "followupCustom",
            label: `${followupstartDate.format("MMM D")} - ${followupendDate.format("MMM D")}`,
            followupstartDate: followupstartDate.format("DD-MM-YYYY"),
            followupendDate: followupendDate.format("DD-MM-YYYY"),
          },
        ]
      : [
          {
            value: "followupCustom",
            label: "Custom Range",
            followupstartDate: null,
            followupendDate: null,
          },
        ]),
  ];
  // --- constants ---
  const FILTER_STORAGE_KEY = "favouriteFilters";

  // --- state ---
  const [favouriteFilters, setFavouriteFilters] = useState<any[]>([]);
  const [favName, setFavName] = useState("");
  const iconKeys = Object.keys(Icons).filter(
    (key) => key.endsWith("Outlined"), // only outlined icons (you can adjust)
  );
  const randomDefaultIcon =
    iconKeys[Math.floor(Math.random() * iconKeys.length)];
  const [selectedIcon, setSelectedIcon] = useState<string>(randomDefaultIcon);

  // --- localStorage helpers ---
  const getFavouriteFilters = (): any[] => {
    try {
      const saved = localStorage.getItem(FILTER_STORAGE_KEY);
      const parsed = saved ? JSON.parse(saved) : [];
      return parsed.filter((f: any) => f.type === "CRM");
    } catch (error) {
      console.error(
        "Failed to parse favourite filters from localStorage",
        error,
      );
      return [];
    }
  };

  const saveFavouriteFilters = (filters: any[]) => {
    try {
      localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(filters));
    } catch (error) {
      console.error("Failed to save favourite filters to localStorage", error);
    }
  };

  const filterFetch = async () => {
    try {
      const localFilters = getFavouriteFilters();
      if (isDeveloper) return;

      const response = await getFilter(); // API call (sorted from backend)

      const serverFilters = Array.isArray(response?.data)
        ? response.data.filter((res: any) => res.type === "CRM")
        : response?.data?.type === "CRM"
          ? [response.data]
          : [];

      const userId = authData?.user?._id;
      const userFilters = serverFilters.filter(
        (sf: any) => sf.userId === userId,
      );

      const mergedFilters = [
        ...localFilters,
        ...userFilters.filter(
          (sf: any) => !localFilters.some((lf) => lf._id === sf._id),
        ),
      ];

      // ✅ Sort by orderId
      mergedFilters.sort((a, b) => (a.orderId ?? 0) - (b.orderId ?? 0));

      saveFavouriteFilters(mergedFilters);
      setFavouriteFilters(mergedFilters);
    } catch (error) {
      console.error("Failed to fetch filters:", error);
    }
  };

  // ✅ Bulk save filter order
  const saveFilterOrder = async (newOrder: any[]) => {
    try {
      const updatedFilters = newOrder.map((filter, index) => ({
        ...filter,
        orderId: index + 1,
      }));

      // 🔁 Update one by one
      await Promise.all(
        updatedFilters.map((f) =>
          updateFilter(f._id, { orderId: f.orderId, type: "CRM" }),
        ),
      );

      // ✅ Update local state + localStorage
      setFavouriteFilters(updatedFilters);
      saveFavouriteFilters(updatedFilters);
    } catch (error) {
      console.error("Failed to save filter order:", error);
    }
  };
  // Drag end handler
  const onDragEnd = (result: any) => {
    if (!result.destination) return;

    const reordered = Array.from(favouriteFilters);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);

    saveFilterOrder(reordered); // 👈 updates backend + localStorage
  };

  const addFavouriteFilter = async (fav: any) => {
    if (!fav.name.trim()) {
      setError("Please enter favorite name!");
      return;
    }
    setError("");

    const filters = getFavouriteFilters();

    const payload = {
      userId: userId || null,
      icon: fav.icon || "",
      name: fav.name,
      source: Array.isArray(selectedSource)
        ? selectedSource
        : selectedSource
          ? [selectedSource]
          : [],
      priority: Array.isArray(selectedPriority)
        ? selectedPriority
        : selectedPriority
          ? [selectedPriority]
          : [],
      country: Array.isArray(selectedCountry)
        ? selectedCountry
        : selectedCountry
          ? [selectedCountry]
          : [],
      status: Array.isArray(selectedStatus)
        ? selectedStatus
        : selectedStatus
          ? [selectedStatus]
          : [],
      owner: Array.isArray(selectedOwner)
        ? selectedOwner
        : selectedOwner
          ? [selectedOwner]
          : [],
      sourceid: Array.isArray(selectedPlatform)
        ? selectedPlatform
        : selectedPlatform
          ? [selectedPlatform]
          : [],
      tags: Array.isArray(selectedTags)
        ? selectedTags
        : selectedTags
          ? [selectedTags]
          : [],
      assignees: selectedAssignee
        ? selectedAssignee
        : selectedAssignee
          ? selectedAssignee
          : null,
      time: timeFilter || null,
      startDate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
      endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null,
      followupdate: followuptimeFilter || null,
      followupstartDate: followupstartDate
        ? dayjs(followupstartDate).format("YYYY-MM-DD")
        : null,
      followupendDate: followupendDate
        ? dayjs(followupendDate).format("YYYY-MM-DD")
        : null,
      isActive: true,
      isDeleted: false,
    };
    try {
      // send payload to backend
      const response = await addFilter(payload);

      // build slug (unique identifier for query params)
      const slug = fav.name.toLowerCase().replace(/\s+/g, "-");

      // build saved filter
      const savedFilter = {
        ...payload,
        _id: response.data?._id,
        slug,
      };

      // save in local storage / state
      filters.push(savedFilter);
      saveFavouriteFilters(filters);
      setFavouriteFilters(filters);

      message.success("Favourite filter saved!");
    } catch (error) {
      console.error("Failed to save filter:", error);
      message.error("Failed to save favourite filter!");
    }
  };

  // --- Delete a favourite filter ---
  // --- Delete a favourite filter (local + backend) ---
  const deleteFavouriteFilter = async (id: string) => {
    try {
      // 1. Call backend delete
      await deleteFilter(id);

      // 2. Remove from local
      const filters = getFavouriteFilters().filter((f) => f._id !== id);
      saveFavouriteFilters(filters);
      setFavouriteFilters(filters);

      message.success("Favourite filter deleted!");
    } catch (error) {
      console.error("Failed to delete filter:", error);
      message.error("Failed to delete favourite filter!");
    }
  };

  // // --- Apply a favourite filter ---
  // const applyFavouriteFilter = (id: number) => {
  //   const fav = favouriteFilters.find(f => f.id === id);
  //   if (!fav) return;

  //   const af = fav.appliedFilters;

  //   setSelectedSource(af.source || null);
  //   setSelectedPlatform(af.platform || null);
  //   setSelectedPriority(af.priority || null);
  //   setSelectedCountry(af.country || null);
  //   setSelectedStatus(af.status || null);
  //   setSelectedOwner(af.owner || null);
  //   setTimeFilter(af.timeFilter || undefined);
  //   setStartDate(af.startDate ? dayjs(af.startDate) : null);
  //   setEndDate(af.endDate ? dayjs(af.endDate) : null);
  // };

  // --- Load favourites on mount ---
  useEffect(() => {
    filterFetch();
    // getFavouriteFilters()
    // setFavouriteFilters(getFavouriteFilters());
  }, []);

  const resetCrmSettings = () => {
    setSelectedSource([]);
    setSelectedPlatform(null);
    setSelectedPriority(null);
    setSelectedCountry(null);
    setTimeFilter(undefined);
    setStartDate(null);
    setEndDate(null);
    setTempStartDate(null);
    setShowRangePicker(false);

    setSelectedStatus([]);
    setSelectedTags([]);
    setfollowupTimeFilter(undefined);
    setfollowupStartDate(null);
    setfollowupEndDate(null);
    setfollowupTempStartDate(null);
    setfollowupTempEndDate(null);
    setfollowupShowRangePicker(false);
    setSelectedAssignee(undefined);
    setSelectedOwner([]);
    setFavName("");
    setError("");
  };

  const CrmSettingsMenu = (
    <div
      style={{
        display: "flex",
        maxWidth: "750px", // ⬅ increased width
        background: "linear-gradient(145deg, #ffffff, #f8fafc)",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        borderRadius: "12px",
        overflow: "hidden",
        padding: "16px",
        gap: "20px",
        height: "85vh", // ⬅ increased height for modal
      }}
    >
      {/* -------- Favorites Section -------- */}
      <div
        style={{
          flex: 1,
          padding: "12px",
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          background: "#fff",
          overflowY: "auto", // ⬅ scroll if filters overflow
          maxHeight: "calc(85vh - 40px)",
        }}
      >
        {/* <h4
          style={{
            fontWeight: 600,
            fontSize: "16px",
            marginBottom: "12px",
            color: "#1f2937",
          }}
        >
          Favorites
        </h4> */}
        {/* --- Saved Favourites --- */}
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                <Table
                  dataSource={favouriteFilters}
                  rowKey={(record: any) => record._id || record.id}
                  pagination={false}
                  size="small"
                  style={{ marginTop: "12px" }}
                  columns={[
                    {
                      title: "Favorites",
                      dataIndex: "name",
                      key: "name",
                      render: (_: any, record: any, index: number) => {
                        const IconComp = (Icons as any)[record.icon];
                        return (
                          <Draggable
                            draggableId={record._id}
                            index={index}
                            key={record._id}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  cursor: "grab",
                                  ...provided.draggableProps.style,
                                }}
                                onClick={() => {
                                  applyFavouriteFilter(record);
                                }}
                              >
                                {IconComp && (
                                  <IconComp style={{ fontSize: "16px" }} />
                                )}
                                <span
                                  style={{
                                    flex: 1,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    maxWidth: "200px",
                                  }}
                                >
                                  {record.name}
                                </span>
                              </div>
                            )}
                          </Draggable>
                        );
                      },
                    },
                    {
                      title: "Action",
                      key: "action",
                      align: "center",
                      width: 72,
                      render: (_: any, record: any) => {
                        const isCopied = copiedId === record._id;
                        return (
                          <div
                            className="fav-action-cell"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "10px",
                            }}
                          >
                            <Tooltip title="Delete">
                              <Icons.DeleteOutlined
                                onClick={(e) => {
                                  e.stopPropagation();
                                  deleteFavouriteFilter(record._id);
                                }}
                                style={{
                                  color: "#ef4444",
                                  cursor: "pointer",
                                  fontSize: "14px",
                                }}
                              />
                            </Tooltip>
                            <Tooltip title={isCopied ? "Copied" : "Copy"}>
                              {isCopied ? (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    lineHeight: 1,
                                    cursor: "default",
                                  }}
                                >
                                  <RiCheckLine
                                    size={14}
                                    style={{ color: "#1890ff" }}
                                  />
                                  <span
                                    style={{
                                      fontSize: "9px",
                                      color: "#1890ff",
                                      marginTop: "2px",
                                    }}
                                  >
                                    Copied
                                  </span>
                                </div>
                              ) : (
                                <RiFileCopyLine
                                  size={14}
                                  className="fav-copy-btn copy-icon"
                                  style={{ cursor: "pointer" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedSource(
                                      record.source?.length
                                        ? record.source
                                        : null,
                                    );
                                    setSelectedPlatform(
                                      record.sourceid?.length
                                        ? record.sourceid
                                        : null,
                                    );
                                    setSelectedPriority(
                                      record.priority?.length
                                        ? record.priority[0]
                                        : null,
                                    );
                                    setSelectedCountry(
                                      record.country?.length
                                        ? record.country[0]
                                        : null,
                                    );
                                    setSelectedStatus(
                                      record.status?.length
                                        ? record.status
                                        : null,
                                    );
                                    setSelectedTags(
                                      record.tags?.length ? record.tags : null,
                                    );
                                    setSelectedAssignee(
                                      record.assignees || undefined,
                                    );
                                    setSelectedOwner(
                                      record.owner?.length
                                        ? record.owner
                                        : null,
                                    );
                                    if (record.time) {
                                      setTimeFilter(record.time);
                                      if (
                                        record.time === "custom" &&
                                        record.startDate &&
                                        record.endDate
                                      ) {
                                        setStartDate(dayjs(record.startDate));
                                        setEndDate(dayjs(record.endDate));
                                      }
                                    } else {
                                      setTimeFilter(undefined);
                                      setStartDate(null);
                                      setEndDate(null);
                                    }
                                    if (record.followupdate) {
                                      setfollowupTimeFilter(
                                        record.followupdate as any,
                                      );
                                      if (
                                        record.followupdate ===
                                          "followupCustom" &&
                                        record.followupstartDate &&
                                        record.followupendDate
                                      ) {
                                        setfollowupStartDate(
                                          dayjs(record.followupstartDate),
                                        );
                                        setfollowupEndDate(
                                          dayjs(record.followupendDate),
                                        );
                                      }
                                    } else {
                                      setfollowupTimeFilter(undefined);
                                      setfollowupStartDate(null);
                                      setfollowupEndDate(null);
                                    }
                                    setCopiedId(record._id);
                                    setTimeout(() => setCopiedId(null), 2000);
                                  }}
                                />
                              )}
                            </Tooltip>
                          </div>
                        );
                      },
                    },
                  ]}
                />
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>

      {/* -------- Filters Section -------- */}
      <div
        style={{
          padding: "12px",
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          background: "#fff",
          overflowY: "auto", // ⬅ scroll if filters overflow
          maxHeight: "calc(85vh - 40px)",
        }}
      >
        <h4
          style={{
            fontWeight: 600,
            fontSize: "16px",
            marginBottom: "12px",
            color: "#1f2937",
          }}
        >
          Filters
        </h4>

        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <div style={{ display: "flex", gap: "8px" }}>
            {/* --- Icon Select --- */}
            <Tooltip
              title="Select an Icon"
              color="#CCCCCC"
              overlayInnerStyle={{
                color: "#000", // ✅ font color
                padding: "12px",
              }}
            >
              <Select
                style={{ width: 80, marginTop: "5px" }}
                showSearch
                placeholder="Select Icon"
                value={selectedIcon}
                onChange={(val) => setSelectedIcon(val)}
                optionFilterProp="children"
                dropdownMatchSelectWidth={false}
                onClick={(e) => e.stopPropagation()}
              >
                {iconKeys.map((key) => {
                  const IconComp = (Icons as any)[key];
                  return (
                    <Option key={key} value={key}>
                      <IconComp style={{ marginRight: 8 }} /> {key}
                    </Option>
                  );
                })}
              </Select>
            </Tooltip>

            {/* --- Name Input --- */}
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Input
                placeholder="Enter favorite name"
                className="Allinput"
                value={favName}
                onChange={(e) => setFavName(e.target.value)}
              />
	              {error && (
	                <span
	                  style={{ color: "red", fontSize: "12px", marginTop: "16px" }}
	                >
	                  {getErrorMessage(error)}
	                </span>
	              )}
            </div>
            {/* --- Save Button --- */}
          </div>
          <Select
            placeholder="Select Source"
            mode="multiple"
            showSearch
            allowClear
            value={selectedSource}
            onChange={(val) => setSelectedSource(val)}
            optionFilterProp="label"
            filterOption={(input, option) =>
              typeof option?.label === "string" &&
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            options={sources.map((item: any) => ({
              value: item._id,
              label: item.name, // plain string (searchable)
              color: item.color, // metadata
            }))}
            optionRender={(option) => (
              <span style={{ color: option.data.color }}>
                {option.data.label}
              </span>
            )}
            style={{ width: "100%" }}
            maxTagCount="responsive"
          />

          <Select
            placeholder="Select Source Platform Name"
            showSearch
            mode="multiple"
            onClick={(e) => e.stopPropagation()}
            allowClear
            value={selectedPlatform} // bind state
            style={{ width: "100%" }}
            maxTagCount="responsive"
            onChange={(val) => setSelectedPlatform(val)} // update state
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.children as unknown as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {platform.map((pla: any) => (
              <Select.Option key={pla._id} value={pla._id}>
                {pla.username}
              </Select.Option>
            ))}
          </Select>

          <Select
            placeholder="Select Priority"
            showSearch
            allowClear
            value={selectedPriority}
            onChange={(val) => setSelectedPriority(val)}
            optionFilterProp="label"
            filterOption={(input, option) =>
              typeof option?.label === "string" &&
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            options={[
              { value: "High", label: "High", color: priorityColors.High },
              {
                value: "Medium",
                label: "Medium",
                color: priorityColors.Medium,
              },
              { value: "Low", label: "Low", color: priorityColors.Low },
            ]}
            optionRender={(option) => (
              <span style={{ color: option.data.color }}>
                {option.data.label}
              </span>
            )}
          />

          <Select
            size="large"
            bordered={false}
            placeholder="Select Country"
            allowClear
            showSearch
            optionFilterProp="children"
            onClick={(e) => e.stopPropagation()}
            value={selectedCountry}
            onChange={(val: any) => setSelectedCountry(val)}
          >
            {countries.map((c) => (
              <Select.Option key={c.code} value={c.name}>
                {c.name}
              </Select.Option>
            ))}
          </Select>

          <Select
            style={{ width: "100%", height: "33px" }}
            value={timeFilter}
            onChange={(value, option) => {
              setTimeFilter(value);
              setPage(1);

              if (value === "custom") {
                if (
                  option &&
                  !Array.isArray(option) &&
                  (option as { startDate?: string; endDate?: string })
                    .startDate &&
                  (option as { startDate?: string; endDate?: string }).endDate
                ) {
                  setStartDate(
                    dayjs((option as { startDate: string }).startDate),
                  );
                  setEndDate(dayjs((option as { endDate: string }).endDate));
                } else {
                  setShowRangePicker(true);
                }
              } else {
                setStartDate(null);
                setEndDate(null);
                setTempStartDate(null);
                setTempEndDate(null);
                setShowRangePicker(false);
              }
            }}
            placeholder="Select Time Filter"
            allowClear
            options={timeFilterOptions}
            optionLabelProp="label"
            dropdownRender={(menu) => (
              <div>
                {menu}
                <div style={{ textAlign: "center" }}>
                  <Button
                    type="link"
                    style={{ color: "red" }}
                    onClick={() => {
                      setTimeFilter(undefined);
                      setStartDate(null);
                      setEndDate(null);
                      setTempStartDate(null);
                      setTempEndDate(null);
                      setShowRangePicker(false);
                    }}
                  >
                    Clear All Filters
                  </Button>
                </div>
              </div>
            )}
          />
          {showRangePicker && (
            <div
              style={{
                position: "fixed",
                top: "25%",
                left: "70%",
                transform: "translate(-50%, -50%)",
                zIndex: 1500,
                background: "#fff",
                padding: "16px",
                boxShadow:
                  "0 3px 6px -4px rgba(0,0,0,0.12), 0 6px 16px 0 rgba(0,0,0,0.08), 0 9px 28px 8px rgba(0,0,0,0.05)",
                borderRadius: "8px",
                width: "fit-content",
              }}
            >
              <DatePicker.RangePicker
                value={
                  tempStartDate && tempEndDate
                    ? [tempStartDate, tempEndDate]
                    : null
                }
                onChange={(dates) => {
                  setTempStartDate(dates ? dates[0] : null);
                  setTempEndDate(dates ? dates[1] : null);
                }}
                format="YYYY-MM-DD"
                style={{ marginBottom: "16px", width: "100%" }}
                allowClear={false}
                getPopupContainer={(triggerNode) => document.body}
                popupStyle={{ zIndex: 2000 }} // make sure it’s above your box
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "8px",
                }}
              >
                <Button
                  onClick={() => {
                    setShowRangePicker(false);
                    setTempStartDate(null);
                    setTempEndDate(null);
                    setTimeFilter(undefined);
                    setStartDate(null);
                    setEndDate(null);
                    setPage(1);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  className="allbuttons text-white deal-apply"
                  onClick={() => {
                    if (tempStartDate && tempEndDate) {
                      setStartDate(tempStartDate);
                      setEndDate(tempEndDate);
                      setShowRangePicker(false);
                      setPage(1);
                      setTimeFilter("custom");
                    }
                  }}
                >
                  Apply
                </Button>
              </div>
            </div>
          )}

          <Select
            mode="multiple"
            showSearch
            allowClear
            placeholder="Select Status"
            value={selectedStatus}
            onChange={(val) => setSelectedStatus(val)}
            optionFilterProp="label"
            filterOption={(input, option) =>
              typeof option?.label === "string" &&
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            options={statuses.map((status: any) => ({
              value: status._id,
              label: status.name,
              color: status.color,
            }))}
            optionRender={(option) => (
              <span style={{ color: option.data.color || "#000000" }}>
                {option.data.label}
              </span>
            )}
            maxTagCount="responsive"
          />

          <Select
            placeholder="Select Tags"
            showSearch
            mode="multiple"
            style={{ width: "100%" }}
            maxTagCount="responsive"
            value={selectedTags}
            onChange={(val) => setSelectedTags(val)}
            allowClear
            optionFilterProp="label"
            filterOption={(input, option) =>
              typeof option?.label === "string" &&
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            options={tags.map((tag: any) => ({
              value: tag._id,
              label: tag.name,
              color: tag.color,
            }))}
            optionRender={(option) => (
              <span style={{ color: option.data.color }}>
                {option.data.label}
              </span>
            )}
          />

          <Select
            style={{ width: "100%", height: "33px" }}
            value={followuptimeFilter}
            onChange={(value, option) => {
              setfollowupTimeFilter(value);
              setPage(1);

              if (value === "followupCustom") {
                if (
                  option &&
                  !Array.isArray(option) &&
                  (
                    option as {
                      followupstartDate?: string;
                      followupendDate?: string;
                    }
                  ).followupstartDate &&
                  (
                    option as {
                      followupstartDate?: string;
                      followupendDate?: string;
                    }
                  ).followupendDate
                ) {
                  setfollowupStartDate(
                    dayjs(
                      (option as { followupstartDate: string })
                        .followupstartDate,
                    ),
                  );
                  setfollowupEndDate(
                    dayjs(
                      (option as { followupendDate: string }).followupendDate,
                    ),
                  );
                } else {
                  setfollowupShowRangePicker(true);
                }
              } else {
                setfollowupStartDate(null);
                setfollowupEndDate(null);
                setfollowupTempStartDate(null);
                setfollowupTempEndDate(null);
                setfollowupShowRangePicker(false);
              }
            }}
            placeholder="Select Follow Up Date"
            allowClear
            options={followupFilterOptions}
            optionLabelProp="label"
            dropdownRender={(menu) => (
              <div>
                {menu}
                <div style={{ textAlign: "center" }}>
                  <Button
                    type="link"
                    style={{ color: "red" }}
                    onClick={() => {
                      setfollowupTimeFilter(undefined);
                      setfollowupStartDate(null);
                      setfollowupEndDate(null);
                      setfollowupTempStartDate(null);
                      setfollowupTempEndDate(null);
                      setShowRangePicker(false);
                    }}
                  >
                    Clear All Filters
                  </Button>
                </div>
              </div>
            )}
          />
          {followupshowRangePicker && (
            <div
              style={{
                position: "fixed",
                top: "25%",
                left: "70%",
                transform: "translate(-50%, -50%)",
                zIndex: 1500,
                background: "#fff",
                padding: "16px",
                boxShadow:
                  "0 3px 6px -4px rgba(0,0,0,0.12), 0 6px 16px 0 rgba(0,0,0,0.08), 0 9px 28px 8px rgba(0,0,0,0.05)",
                borderRadius: "8px",
                width: "fit-content",
              }}
            >
              <DatePicker.RangePicker
                value={
                  followuptempStartDate && followuptempEndDate
                    ? [followuptempStartDate, followuptempEndDate]
                    : null
                }
                onChange={(dates) => {
                  setfollowupTempStartDate(dates ? dates[0] : null);
                  setfollowupTempEndDate(dates ? dates[1] : null);
                }}
                format="YYYY-MM-DD"
                style={{ marginBottom: "16px", width: "100%" }}
                allowClear={false}
                getPopupContainer={(triggerNode) => document.body}
                popupStyle={{ zIndex: 2000 }} // make sure it’s above your box
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "8px",
                }}
              >
                <Button
                  onClick={() => {
                    setfollowupShowRangePicker(false);
                    setfollowupTempStartDate(null);
                    setfollowupTempEndDate(null);
                    setfollowupTimeFilter(undefined);
                    setfollowupStartDate(null);
                    setfollowupEndDate(null);
                    setPage(1);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  className="allbuttons text-white deal-apply"
                  onClick={() => {
                    if (followuptempStartDate && followuptempEndDate) {
                      setfollowupStartDate(followuptempStartDate);
                      setfollowupEndDate(followuptempEndDate);
                      setfollowupShowRangePicker(false);
                      setPage(1);
                      setfollowupTimeFilter("followupCustom");
                    }
                  }}
                >
                  Apply
                </Button>
              </div>
            </div>
          )}

          <Select
            placeholder="Select Lead Assignee"
            showSearch
            onClick={(e) => e.stopPropagation()}
            allowClear
            value={selectedAssignee}
            style={{ width: "100%" }}
            maxTagCount="responsive"
            onChange={(val) => setSelectedAssignee(val)}
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.children as unknown as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {developers.map((pla: any) => (
              <Select.Option key={pla._id} value={pla._id}>
                {pla.username}
              </Select.Option>
            ))}
          </Select>

          {isAdmin && (
            <Select
              placeholder="Select Owner Name"
              showSearch
              mode="multiple"
              onClick={(e) => e.stopPropagation()}
              allowClear
              style={{ width: "100%" }}
              maxTagCount="responsive"
              value={selectedOwner}
              onChange={(val) => setSelectedOwner(val)}
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children as unknown as string)
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {developers.map((dev: any) => (
                <Select.Option key={dev._id} value={dev._id}>
                  {dev.username}
                </Select.Option>
              ))}
            </Select>
          )}
          <div className="flex justify-end mt-1">
            {/* <Tooltip title="Save" color="#CCCCCC"
              overlayInnerStyle={{
                color: "#000",   // ✅ font color
              }} > */}
            <button
              className="allsubmitebutton flex items-center justify-center"
              style={{
                width: "53px",
                height: "30px",
                borderRadius: "6px",
              }}
              type="submit"
              onClick={(e) => {
                e.stopPropagation();
                addFavouriteFilter({
                  name: favName,
                  icon: selectedIcon,
                });

                // clear after save
                setFavName("");
                setSelectedIcon("");
              }}
            >
              Save
            </button>
            {/* </Tooltip> */}
          </div>
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    const SettingData = async () => {
      try {
        const response = await GetSettingData();
        // if (response.settings && response.settings[0] && response.settings[0].logo  ) {
        //   setLogo(response.settings[0].logo );
        // }
        const settingData = response.settings[0];
        const logoImage = `${settingImageUrl}/${settingData.logo}`;
        const faviconImage = `${settingImageUrl}/${settingData.favicon}`;
        updateSettings({
          siteName: settingData.siteName,
          logo: logoImage,
          favicon: faviconImage,
        });
        // setLogo(response.settings[0].logo);
      } catch (error) {
        console.error("Error fetching setting data:", error);
      }
    };

    SettingData();
  }, []);

  useEffect(() => {
    const savedCollapsed = localStorage.getItem("sidebarCollapsed");
    if (savedCollapsed !== null) {
      setCollapsed(JSON.parse(savedCollapsed));
    } else {
      setCollapsed(false); // Default to false if no value is saved
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("sidebarCollapsed", "false");
  }, [collapsed]);

  const handleMouseEnter = () => {
    if (disableHover) return;
    setIsHovering(true);
    if (collapsed) {
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        setHoverTimeout(null);
      }
      setHoverEffectActive(false);
      const savedOpenKeys = localStorage.getItem("sidebarOpenKeys");
      if (savedOpenKeys) {
        setOpenKeys(JSON.parse(savedOpenKeys));
      }
    }
  };

  const handleMouseLeave = () => {
    if (disableHover) return;
    setIsHovering(false);
    if (collapsed) {
      const timeout = setTimeout(() => {
        setHoverEffectActive(true);
        localStorage.setItem("sidebarOpenKeys", JSON.stringify(openKeys));
        setOpenKeys([]);
      }, 300);
      setHoverTimeout(timeout);
    }
  };

  const userPermissions = Array.isArray(authData?.permissions)
    ? authData.permissions
    : [];

  // Create a helper function to check permissions
  const hasPermission = (
    menuSlug: string,
    action:
      | "all"
      | "visible"
      | "get"
      | "create"
      | "update"
      | "delete" = "visible",
  ) => {
    if (isAdmin) return true; // Admin has access to everything
    // if (!menuSlug) return false;

    const permission = userPermissions.find(
      (p: any) => p?.menuId?.slug === menuSlug,
    );

    return Boolean(permission?.permissionIds?.[action]);
  };

  // Now let's modify your menu items to check permissions
  const menuItems = [
    {
      key: "dashboard",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1.2em"
          height="1.2em"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ color: "inherit" }}
        >
          <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          <polyline points="9 22 9 12 15 12 15 22" />
        </svg>
      ),
      text: "Dashboard",
      link: "/dashboard",
      permission: "dashboard",
    },
    ...(isAdmin || hasPermission("customers")
      ? [
          {
            key: "customers",
            icon: (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1.2em"
                height="1.2em"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ color: "inherit" }}
              >
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            ),
            text: "Customers",
            link: "/customers",
            permission: "customers",
          },
        ]
      : []),

      ...(isAdmin || hasPermission("projects")
      ? [
          {
            key: "project",
            icon: (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1.2em"
                height="1.2em"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ color: "inherit" }}
              >
                <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
                <line x1="16" x2="16" y1="2" y2="6" />
                <line x1="8" x2="8" y1="2" y2="6" />
                <line x1="3" x2="21" y1="10" y2="10" />
              </svg>
            ),
            text: "Projects",
            link: "/projects",
            permission: "projects",
          },
        ]
      : []),

    // ...(isAdmin || hasPermission("social-media")
    //   ? [
    //       {
    //   key: "social-media",
    //   icon: (
    //     <svg
    //       xmlns="http://www.w3.org/2000/svg"
    //       width="1.2em"
    //       height="1.2em"
    //       viewBox="0 0 24 24"
    //       fill="none"
    //       stroke="currentColor"
    //       strokeWidth="2"
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //       style={{ color: "inherit" }}
    //     >
    //       <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    //       <polyline points="7 10 12 15 17 10" />
    //       <line x1="12" x2="12" y1="15" y2="3" />
    //     </svg>
    //   ),
    //   text: "Social Media",
    //   link: "/social-media",
    //   permission: "social-media",
    // },
    //     ]
    //   : []),

    {
      key: "task",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1.2em"
          height="1.2em"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ color: "inherit" }}
        >
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
      ),
      text: "Tasks",
      link: "/tasks",
      matchPaths: ["/tasks", "/task"],
      permission: "tasks",
    },
  ].filter((item) => isAdmin || hasPermission(item.permission));

  // Similarly, modify your masterSubmenu
  const masterSubmenu =
    authData &&
    (isAdmin ||
      hasPermission("developers") ||
      hasPermission("projects") ||
      hasPermission("designations") ||
      hasPermission("email_template"))
      ? {
          key: "master",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1.2em"
              height="1.2em"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ color: "inherit" }}
            >
              <ellipse cx="12" cy="5" rx="9" ry="3" />
              <path d="M3 5v14m18-14v14" />
              <path d="M3 12c0 1.66 4 3 9 3s9-1.34 9-3" />
              <path d="M3 19c0 1.66 4 3 9 3s9-1.34 9-3" />
            </svg>
          ),
          text: "Master",
          children: [
            ...(isAdmin || hasPermission("designations")
              ? [
                  {
                    key: "designation",
                    icon: <SolutionOutlined style={{ color: "inherit" }} />,
                    text: "Designations",
                    link: "/designations",
                    permission: "designations",
                  },
                ]
              : []),
            ...(isAdmin || hasPermission("developers")
              ? [
                  {
                    key: "developers",
                    icon: <LaptopOutlined style={{ color: "inherit" }} />,
                    text: "Teams",
                    link: "/developers",
                    permission: "developers",
                  },
                ]
              : []),
            ...(isAdmin || hasPermission("source")
              ? [
                  {
                    key: "source",
                    icon: <CodepenOutlined style={{ color: "inherit" }} />,
                    text: "Source",
                    link: "/source",
                    permission: "source",
                  },
                ]
              : []),
            ...(isAdmin || hasPermission("tags")
              ? [
                  {
                    key: "tags",
                    icon: <TagOutlined style={{ color: "inherit" }} />,
                    text: "Tags",
                    link: "/tags",
                    permission: "tags",
                  },
                ]
              : []),

            ...(isAdmin || hasPermission("shift")
              ? [
                  {
                    key: "shift",
                    icon: <BsClockHistory style={{ color: "inherit" }} />,
                    text: "Shifts",
                    link: "/shift",
                    permission: "shift",
                  },
                ]
              : []),

            ...(isAdmin || hasPermission("email_template")
              ? [
                  {
                    key: "email_template",
                    icon: <MailOutlined style={{ color: "inherit" }} />,
                    text: "Email Templates",
                    link: "/email-templates",
                    permission: "email_template",
                  },
                ]
              : []),
                      ].filter(Boolean),
        }
      : null;

  // Modify your attendanceSubmenu
  const hasHRMSPermission =
    hasPermission("attendances") ||
    hasPermission("leave") ||
    hasPermission("overtime") ||
    hasPermission("job-applications") ||
    hasPermission("resignation");

  const attendanceSubmenu = hasHRMSPermission
    ? {
        key: "HRMS",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1.2em"
            height="1.2em"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ color: "inherit" }}
          >
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M17.5 17.5c-1.31 0-2.5-.5-3.35-1.35s-1.35-2.04-1.35-3.35" />
            <path d="M20.9 2.1l-6.6 6.6" />
          </svg>
        ),
        text: "HRMS",
        children: [
          ...(authData && (isAdmin || hasPermission("job-applications"))
            ? [
                {
                  key: "jobapplications",
                  icon: <ProfileOutlined style={{ color: "inherit" }} />,
                  text: "Job Applications",
                  link: "/jobapplications",
                  permission: "job-applications",
                },
              ]
            : []),
          ...(isAdmin || hasPermission("leave")
            ? [
                {
                  key: "leave",
                  icon: <FileTextOutlined style={{ color: "inherit" }} />,
                  text: "Leaves",
                  link: "/leave",
                  permission: "leave",
                },
              ]
            : []),
          ...(isAdmin || hasPermission("attendances")
            ? [
                {
                  key: "attendance",
                  icon: <CheckSquareOutlined style={{ color: "inherit" }} />,
                  text: "Attendance",
                  link: "/attendance",
                  permission: "attendances",
                },
              ]
            : []),
          ...(isAdmin || hasPermission("campus-off")
            ? [
                {
                  key: "Campassoff",
                  icon: <CompassOutlined style={{ color: "inherit" }} />,
                  text: "Campus Off",
                  link: "/campus-off",
                  permission: "campus-off",
                },
              ]
            : []),
          ...(authData && (isAdmin || hasPermission("misspunch"))
            ? [
                {
                  key: "misspunch",
                  icon: <ClockCircleOutlined style={{ color: "inherit" }} />,
                  text: "MissPunch",
                  link: "/misspunch",
                  permission: "misspunch",
                },
              ]
            : []),
          ...(isAdmin || hasPermission("overtime")
            ? [
                {
                  key: "overtime",
                  icon: <MacCommandOutlined style={{ color: "inherit" }} />,
                  text: "Overtime",
                  link: "/overtime",
                  permission: "overtime",
                },
              ]
            : []),
          ...(isAdmin || hasPermission("holidays")
            ? [
                {
                  key: "holidays",
                  icon: <CalendarOutlined style={{ color: "inherit" }} />,
                  text: "Holidays",
                  link: "/holidays",
                  permission: "holidays",
                },
              ]
            : []),
          ...(isAdmin || hasPermission("resignation")
            ? [
                {
                  key: "Resignation",
                  icon: <FileOutlined style={{ color: "inherit" }} />,
                  text: "Resignation",
                  link: "/resignation",
                  permission: "resignation",
                },
              ]
            : []),
        ].filter(Boolean),
      }
    : null;

  // Modify CRM submenu
  const hasCRMPermission =
    hasPermission("contacts") ||
    hasPermission("companies") ||
    hasPermission("rawdata") ||
    hasPermission("leads") ||
    hasPermission("deals");

  const CrmSubmenu =
    authData && (isAdmin || hasCRMPermission)
      ? {
          key: "crm",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1.2em"
              height="1.2em"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ color: "inherit" }}
            >
              <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.34 0-2.61.56-3.7 1.47-1.09-.91-2.36-1.47-3.7-1.47A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
            </svg>
          ),
          text: "CRM",
          children: [
            ...(isAdmin || hasPermission("contacts")
              ? [
                  {
                    key: "contacts",
                    icon: <ContactsOutlined style={{ color: "inherit" }} />,
                    text: "Contacts",
                    link: "/contacts",
                    permission: "contacts",
                  },
                ]
              : []),
            ...(isAdmin || hasPermission("companies")
              ? [
                  {
                    key: "companies",
                    icon: <CodeSandboxOutlined style={{ color: "inherit" }} />,
                    text: "Companies",
                    link: "/companies",
                    permission: "companies",
                  },
                ]
              : []),
            // ...(isAdmin || hasPermission("rawdata") ? [{
            //   key: "SourceData",
            //   icon: <DatabaseOutlined style={{ color: "inherit" }} />,
            //   text: "Source Data",
            //   link: "/rawdata",
            //   permission: "rawdata"
            // }] : []),
            // Add other CRM items with permission checks
            ...favouriteFilters
              .map((fav) => {
                const IconComp = (Icons as any)[fav.icon];

                // Build query string dynamically
                const queryParams = new URLSearchParams();

                if (fav.source?.length)
                  queryParams.set("source", fav.source.join(","));
                if (fav.sourceid?.length)
                  queryParams.set("sourceid", fav.sourceid.join(","));
                if (fav.priority?.length)
                  queryParams.set("priority", fav.priority.join(","));
                if (fav.country?.length)
                  queryParams.set("country", fav.country.join(","));
                if (fav.status?.length)
                  queryParams.set("status", fav.status.join(","));
                if (fav.tags?.length)
                  queryParams.set("tags", fav.tags.join(","));
                if (fav.owner?.length)
                  queryParams.set("owner", fav.owner.join(","));
                if (fav.assignees) queryParams.set("Assignee", fav.assignees);
                if (fav.time) queryParams.set("time", fav.time);
                if (fav.startDate) queryParams.set("startDate", fav.startDate);
                if (fav.endDate) queryParams.set("endDate", fav.endDate);
                if (fav.followupdate)
                  queryParams.set("followupdate", fav.followupdate);
                if (fav.followupstartDate)
                  queryParams.set("followupstartDate", fav.followupstartDate);
                if (fav.followupendDate)
                  queryParams.set("followupendDate", fav.followupendDate);

                return {
                  key: fav.slug,
                  icon: fav.icon ? (
                    <IconComp style={{ color: "inherit" }} />
                  ) : (
                    <i className="fas fa-star text-gray-500" />
                  ),
                  text: fav.name,
                  link: `/rawdata?slug=${fav.slug}&${queryParams.toString()}`,
                };
              })
              .filter(Boolean),
          ].filter(Boolean),
        }
      : null;

  // Modify Analytics menu
  const hasAnalyticsPermission =
    hasPermission("leads-analytics") ||
    hasPermission("job-application-analytics");

  const AnalyticsMenu =
    authData && (isAdmin || hasAnalyticsPermission)
      ? {
          key: "Analytics",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1.2em"
              height="1.2em"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ color: "inherit" }}
            >
              <path d="M2 13a4 4 0 0 0 4 4 4 4 0 0 0 4-4 4 4 0 0 0-4-4 4 4 0 0 0-4 4z" />
              <path d="M22 13a4 4 0 0 0-4-4 4 4 0 0 0-4 4 4 4 0 0 0 4 4 4 4 0 0 0 4-4z" />
              <path d="M10 13a4 4 0 0 0-4-4h8" />
            </svg>
          ),
          text: "Analytics",
          children: [
            ...(isAdmin || hasPermission("leads-analytics")
              ? [
                  {
                    key: "Leads",
                    icon: <LineChartOutlined style={{ color: "inherit" }} />,
                    text: "Leads",
                    link: "/leadsAnalytics",
                    permission: "leads-analytics",
                  },
                ]
              : []),
            ...(isAdmin || hasPermission("job-application-analytics")
              ? [
                  {
                    key: "JobApplication",
                    icon: <ProfileOutlined style={{ color: "inherit" }} />,
                    text: "Job Application",
                    link: "/jobApplicationAnalytics",
                    permission: "job-application-analytics",
                  },
                ]
              : []),
          ].filter(Boolean),
        }
      : null;

  // Accounting menu
  const hasAccountingPermission =
    hasPermission("receipts") ||
    hasPermission("expense") ||
    hasPermission("invoice");

  const AccountingMenu =
    authData && (isAdmin || hasAccountingPermission)
      ? {
          key: "Accounting",
          icon: (
            <MdCurrencyRupee
              size="1.2em"
              style={{
                stroke: "currentColor",
                strokeWidth: 2,
                fill: "none", // removes default fill
              }}
            />
          ),
          text: "Accounting",
          children: [
            ...(isAdmin || hasPermission("receipts")
              ? [
                  {
                    key: "receipts",
                    icon: <IoReceiptOutline style={{ color: "inherit" }} />,
                    text: "Receipts",
                    link: "/receipts",
                    permission: "receipts",
                  },
                ]
              : []),
            ...(isAdmin || hasPermission("expense")
              ? [
                  {
                    key: "expense",
                    icon: <WalletOutlined style={{ color: "inherit" }} />,
                    text: "Expenses",
                    link: "/expense",
                    permission: "expense",
                  },
                ]
              : []),
            ...(isAdmin || hasPermission("invoice")
              ? [
                  {
                    key: "invoice",
                    icon: (
                      <LiaFileInvoiceSolid
                        size={20}
                        style={{ color: "inherit" }}
                      />
                    ),
                    text: "Invoices",
                    link: "/invoice",
                    permission: "invoice",
                  },
                ]
              : []),
          ].filter(Boolean),
        }
      : null;

 

  const AmcItem =
    authData && (isAdmin || hasPermission("amc-maintenance"))
      ? {
          //...(isAdmin || hasPermission("amc-maintenance") ? [{
          key: "amc maintenance",
          icon: <MdBuild size={20} style={{ color: "inherit" }} />,
          text: "AMC Maintenance",
          link: "/amc-maintenance",
          permission: "amc-maintenance",
        }
      : null;

  // Other menu items with permission checks
  const CalendarItem =
    authData && (isAdmin || hasPermission("calender"))
      ? {
          key: "calendar",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1.2em"
              height="1.2em"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ color: "inherit" }}
            >
              <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
              <line x1="16" x2="16" y1="2" y2="6" />
              <line x1="8" x2="8" y1="2" y2="6" />
              <line x1="3" x2="21" y1="10" y2="10" />
            </svg>
          ),
          text: "Calendar",
          link: "/calendar",
          permission: "calender",
        }
      : null;

  const ReportItem =
    authData && (isAdmin || hasPermission("report"))
      ? {
          key: "report",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1.2em"
              height="1.2em"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ color: "inherit" }}
            >
              <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" x2="8" y1="13" y2="13" />
              <line x1="16" x2="8" y1="17" y2="17" />
              <line x1="10" x2="8" y1="9" y2="9" />
            </svg>
          ),
          text: "Report",
          link: "/report",
          permission: "report",
        }
      : null;

  const rolesPermissionItem =
    authData &&
    (isAdmin || hasPermission("roles") || hasPermission("permissions"))
      ? {
          key: "roles",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1.2em"
              height="1.2em"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ color: "inherit" }}
            >
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              <path d="m9 12 2 2 4-4" />
            </svg>
          ),
          text: "Roles & Permission",
          link: "/roles",
          permission: "roles",
        }
      : null;

  const settingsItem =
    authData && (isAdmin || hasPermission("settings"))
      ? {
          key: "settings",
          icon: <SettingOutlined style={{ color: "inherit" }} />,
          text: "Settings",
          link: "/settings",
          permission: "settings",
        }
      : null;

  const NotificationConfigurationItem =
    authData && (isAdmin || hasPermission("notifications"))
      ? {
          key: "notifications",
          icon: <BellOutlined style={{ color: "inherit" }} />,
          text: "Notification",
          link: "/notifications",
          permission: "notifications",
        }
      : null;

  // Debug logs for chatbot permission check
  // console.log("Debug - authData:", authData);
  // console.log("Debug - hasPermission('Chatbot', 'get'):", hasPermission("Chatbot", "get"));

  const chatbotItem =
    authData && hasPermission("Chatbot", "get")
      ? {
          key: "Chatbot",
          icon: (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "1.2em",
                height: "1.2em",
              }}
            >
              <RobotOutlined style={{ color: "inherit", fontSize: "1.2em" }} />
            </span>
          ),
          text: "AI Chatbot",
          link: "/chat",
          permission: "Chatbot",
        }
      : null;

  // console.log("Debug - chatbotItem:", chatbotItem);

  // ...(isAdmin || hasPermission("Chatbot") ? [{
  //   key: "Chatbot",
  //   icon: <svg xmlns="http://www.w3.org/2000/svg" width="1.2em"
  //     height="1.2em"
  //     viewBox="0 0 24 24"
  //     fill="none"
  //     stroke="currentColor"
  //     strokeWidth="2"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //     style={{ color: "inherit" }}>
  //     <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
  //     <line x1="16" x2="16" y1="2" y2="6" />
  //     <line x1="8" x2="8" y1="2" y2="6" />
  //     <line x1="3" x2="21" y1="10" y2="10" />
  //   </svg>
  //   ,
  //   text: "Chatbot",
  //   link: "/chat",
  //   permission: "Chatbot"
  // }] : []),

  const rootSubmenuKeys = [
    masterSubmenu ? "master" : null,
    attendanceSubmenu ? "HRMS" : null,
    CrmSubmenu ? "crm" : null,
    AnalyticsMenu ? "Analytics" : null,
    AccountingMenu ? "Accounting" : null,
    // NotificationConfigurationItem ? "notificationrule" : null,
    rolesPermissionItem ? "roles" : null,
    settingsItem ? "settings" : null,
    AmcItem ? "amc maintenance" : null,
    CalendarItem ? "calendar" : null,
    ReportItem ? "report" : null,
  ].filter(Boolean) as string[];

  const onOpenChange = (keys: string[]) => {
    // When sidebar is collapsed, we want to keep track of what was opened
    // but only show one submenu at a time
    if (collapsed) {
      const latestOpenKey = keys.find((key) => !openKeys.includes(key));
      if (latestOpenKey && rootSubmenuKeys.includes(latestOpenKey)) {
        setOpenKeys([latestOpenKey]);
      } else {
        setOpenKeys([]);
      }
    } else {
      // When not collapsed, behave normally
      const latestOpenKey = keys.find((key) => !openKeys.includes(key));
      if (latestOpenKey && rootSubmenuKeys.includes(latestOpenKey)) {
        setOpenKeys([latestOpenKey]);
      } else {
        setOpenKeys(keys);
      }
    }
  };

  useEffect(() => {
    const headerOnlyPaths = ["/profile"];
    const isHeaderRoute = headerOnlyPaths.some((path) =>
      location.pathname.startsWith(path),
    );

    if (isHeaderRoute) {
      setActiveMenuItemKey(null);
      return;
    }

    const allItems = [
      ...menuItems,
      ...(attendanceSubmenu?.children || []),
      ...(masterSubmenu?.children || []),
      ...(CrmSubmenu?.children || []),
      ...(AnalyticsMenu?.children || []),
      ...(AccountingMenu?.children || []),
      ...(AmcItem ? [AmcItem] : []),
      ...(CalendarItem ? [CalendarItem] : []),
      ...(ReportItem ? [ReportItem] : []),
      ...(rolesPermissionItem ? [rolesPermissionItem] : []),
      ...(settingsItem ? [settingsItem] : []),
      ...(NotificationConfigurationItem ? [NotificationConfigurationItem] : []),
      ...(chatbotItem ? [chatbotItem] : []),
    ].filter(Boolean);

    const currentItem = allItems.find(
      (item: any) =>
        item &&
        (currentPathWithQuery === item.link || // exact match with query
          (item.link && currentPathWithQuery.startsWith(item.link + "/")) ||
          item.matchPaths?.some((path: any) =>
            currentPathWithQuery.startsWith(path),
          )),
    );

    let newOpenKeys: string[] = [];

    if (currentItem) {
      setActiveMenuItemKey(currentItem.key);
      setSelectedKeys([currentItem.key]);

      const parentKey = masterSubmenu?.children.some(
        (c) => c.key === currentItem?.key,
      )
        ? "master"
        : attendanceSubmenu?.children.some((c) => c.key === currentItem?.key)
          ? "HRMS"
          : CrmSubmenu?.children.some((c) => c.key === currentItem?.key)
            ? "crm"
            : AnalyticsMenu?.children.some((c) => c.key === currentItem?.key)
              ? "Analytics"
              : AccountingMenu?.children.some((c) => c.key === currentItem?.key)
                ? "Accounting"
                // : NotificationConfigurationItem && NotificationConfigurationItem.key === currentItem?.key
                //   ? "notificationrule"
                  : null;
      if (parentKey) {
        newOpenKeys = [parentKey];
      }
    } else {
      setActiveMenuItemKey(null);
    }

    if (!collapsed || isHovering) {
      setOpenKeys(newOpenKeys);
      localStorage.setItem("sidebarOpenKeys", JSON.stringify(newOpenKeys));
    } else {
      setOpenKeys([]);
    }
  }, [location.pathname, collapsed, isHovering]);

  useEffect(() => {
    return () => {
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
      }
    };
  }, [hoverTimeout]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.setItem("sidebarOpenKeys", JSON.stringify(openKeys));
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [openKeys]);

  const handleMenuItemClick = (key: string) => {
    console.log("Menu item clicked:", key);
    // Determine which parent submenu contains the clicked item
    const parentSubmenu = masterSubmenu?.children.some(
      (child) => child.key === key,
    )
      ? "master"
      : attendanceSubmenu?.children.some((child) => child.key === key)
        ? "HRMS"
        : CrmSubmenu?.children.some((child) => child.key === key)
          ? "crm"
          // : NotificationConfigurationItem && NotificationConfigurationItem.key === key
          //   ? "notificationrule"
            : rolesPermissionItem && rolesPermissionItem.key === key
              ? "roles"
              : settingsItem && settingsItem.key === key
                ? "settings"
                : CalendarItem && CalendarItem.key === key
                  ? "calendar"
                  : AmcItem && AmcItem.key === key
                    ? "amc maintenance"
                    : ReportItem && ReportItem.key === key
                      ? "report"
                      : null;
    console.log("Parent submenu:", parentSubmenu);
    if (parentSubmenu && !openKeys.includes(parentSubmenu)) {
      setOpenKeys([...openKeys, parentSubmenu]);
    }

    setHoverEffectActive(false);
    setIsHovering(false);
    // setCollapsed(false);

    fetchNotifications();

    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      setHoverTimeout(null);
    }

    onItemClick?.();
  };

  useEffect(() => {
    localStorage.setItem("sidebarOpenKeys", JSON.stringify(openKeys));
  }, [openKeys]);

  const routeTitles = {
    "/dashboard": "Dashboard",
    // "/social-media": "Social Media",
    "/customers": "Customers",
    "/backend/customers/add": "Add Customer",
    "/customers/edit/:id": "Edit Customer",
    "/tasks": "Tasks",
    "/backend/tasks/add": "Add Task",
    "/tasks/:id/edit": "Edit Task",
    "/task": "Tasks",
    "/projects": "Projects",
    "/backend/projects/add": "Add Project",
    "/projects/:id/edit": "Edit Project",
    "/designations": "Designations",
    "/backend/designations/add": "Add Designation",
    "/designations/edit/:id": "Edit Designation",
    "/developers": "Teams",
    "/developers/backend/developer/add": "Add Team",
    "/developers/backend/developer/add/developer/:id/edit": "Edit Team",
    "/leave": "Leave",
    "/leave/apply-Leave": "Apply Leave",
    "/attendance": "Attendance",
    "/attendance/:id/edit": "Edit Attendance",
    "/overtime": "Overtime",
    "/overtime/add-overtime": "Add Overtime",
    "/overtime/:id/edit": "Overtime | Edit Overtime",
    "/misspunch": "MissPunch",
    "/roles": "Roles & Permission",
    "/backend/roles/add": "Add Role",
    "/roles/edit/:id": "Edit Role",
    "/profile": "Profile",
    "/holidays": "Holidays",
    "/backend/holidays/add": "Add Holiday",
    "/jobapplications": "Job Applications",
    "/resignation": "Resignation",
    "/campus-off": "Campassoff",
    "/contacts": "Contacts",
    "/companies": "Companies",
    "/leadsAnalytics": "Analytics",
    "/jobApplicationAnalytics": "Analytics",
    "/receipts": "Receipts",
    "/expense": "Expense",
    "/invoice": "Invoice",
    "/deals": "Deals",
    "/leads": "Leads",
    "/rawdata": "Source Data",
    "/calendar": "Calendar",
    "/report": "Report",
    "/expenseType": "Expense Type",
  };

  useEffect(() => {
    let title = "Encrypted Infoweb";
    if (routeTitles[location.pathname as keyof typeof routeTitles]) {
      title = `${routeTitles[location.pathname as keyof typeof routeTitles]} | Encrypted Infoweb`;
    } else {
      for (const [path, pathTitle] of Object.entries(routeTitles)) {
        if (
          path.includes(":") &&
          new RegExp(`^${path.replace(/:[^/]+/g, "[^/]+")}$`).test(
            location.pathname,
          )
        ) {
          title = `${pathTitle} | Encrypted Infoweb`;
          break;
        }
      }
    }
    document.title = title;
  }, [location.pathname]);

  function toggleCollapse(): void {
    onCollapse(!collapsed);
  }

  //   useEffect(() => {
  //   const path = location.pathname;

  //   // Check if it's a CRM child
  //   const crmChild = CrmSubmenu?.children.find(c => c.link === path);
  //   if (crmChild) {
  //     setSelectedKeys([crmChild.key]);
  //     return;
  //   }

  //   // Check if it's a favourite
  //   const fav = favouriteFilters.find(f => f.link === path);
  //   if (fav) {
  //     setSelectedKeys([`fav-${fav._id}`]);
  //     return;
  //   }

  //   // Default for other menus
  //   setSelectedKeys([path]);
  // }, [location.pathname, CrmSubmenu, favouriteFilters]);

  return (
    <>
      {isSmallScreen ? (
        <Drawer
          placement="left"
          closable={true}
          onClose={toggleCollapse}
          width="200px"
          open={!collapsed}
          maskClosable
          bodyStyle={{
            backgroundColor: "#001529",
            padding: 0,
            overflowY: "auto",
          }}
        >
          <div
            style={{
              backgroundColor: "#001529",
              padding: "1rem 0",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src={settings ? settings.logo : Logo_Main}
              alt="logo"
              style={{ maxHeight: "8vw" }}
            />
          </div>
          <div style={{ maxHeight: "calc(100vh - 60px)", overflowY: "auto" }}>
            <Menu
              mode="inline"
              theme="dark"
              selectedKeys={[activeMenuItemKey].filter(Boolean) as string[]}
              openKeys={openKeys}
              onOpenChange={onOpenChange}
              style={{
                color: "white",
                width: "100%",
              }}
              forceSubMenuRender
            >
              {menuItems.map((item) => (
                <Menu.Item
                  key={item.key}
                  icon={<span style={{ fontSize: "30px" }}>{item.icon}</span>}
                  onClick={() => {
                    onItemClick();
                    setCollapsed(true);
                    handleMenuItemClick(item.key);
                    navigate(item.link);
                  }}
                >
                  <Link
                    to={item.link}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {item.text}
                  </Link>
                </Menu.Item>
              ))}

              {masterSubmenu && (
                <SubMenu
                  key={masterSubmenu.key}
                  icon={
                    <span style={{ fontSize: "30px" }}>
                      {masterSubmenu.icon}
                    </span>
                  }
                  title={masterSubmenu.text}
                >
                  {masterSubmenu.children.map((child) => (
                    <Menu.Item
                      key={child.key}
                      icon={
                        <span style={{ fontSize: "20px" }}>{child.icon}</span>
                      }
                      onClick={() => {
                        onItemClick();
                        setCollapsed(true);
                        handleMenuItemClick(child.key);
                        navigate(child.link);
                      }}
                    >
                      <Link
                        to={child.link}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {child.text}
                      </Link>
                    </Menu.Item>
                  ))}
                </SubMenu>
              )}

              {attendanceSubmenu && (
                <SubMenu
                  key={attendanceSubmenu.key}
                  icon={
                    <span style={{ fontSize: "30px" }}>
                      {attendanceSubmenu.icon}
                    </span>
                  }
                  title={attendanceSubmenu.text}
                >
                  {attendanceSubmenu.children.map((child) => (
                    <Menu.Item
                      key={child.key}
                      icon={
                        <span style={{ fontSize: "20px" }}>{child.icon}</span>
                      }
                      onClick={() => {
                        onItemClick();
                        setCollapsed(true);
                        handleMenuItemClick(child.key);
                        navigate(child.link);
                      }}
                    >
                      <Link
                        to={child.link}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {child.text}
                      </Link>
                    </Menu.Item>
                  ))}
                </SubMenu>
              )}

              {CrmSubmenu && (
                <SubMenu
                  key={CrmSubmenu.key}
                  icon={React.cloneElement(CrmSubmenu.icon, {
                    style: {
                      fontSize:
                        collapsed && hoverEffectActive ? "20px" : "16px",
                    },
                  })}
                  title={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      CRM
                      <Button
                        type="text"
                        style={{ color: "white" }}
                        size="small"
                        icon={<SettingOutlined />}
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsCrmSettingsOpen(true); // open modal
                        }}
                      />
                      <Modal
                        destroyOnClose
                        style={{
                          bottom: 20,
                          top: 20,
                          // maxHeight: 'calc(100vh - 30px)',
                          margin: "0 auto",
                          position: "relative",
                        }}
                        styles={{
                          body: {
                            overflowY: "auto",
                            fontFamily: "inter, sans-serif",
                          },
                          header: {
                            padding: "12px",
                            position: "sticky",
                            top: 0,
                            backgroundColor: "#f1f5ffff",
                          },
                          content: {
                            padding: 0,
                            overflow: "hidden",
                          },
                        }}
                        title={
                          <div
                            style={{
                              color: "#4b5563",
                              fontFamily: "inter, sans-serif",
                              fontSize: "20px",
                              fontWeight: 500,
                            }}
                          >
                            CRM Favourite Filter
                          </div>
                        }
                        open={isCrmSettingsOpen}
                        onCancel={(e) => {
                          e.stopPropagation();
                          resetCrmSettings(); // ✅ clear all values
                          setIsCrmSettingsOpen(false);
                        }}
                        footer={null}
                        width={600}
                      >
                        {/* 🛑 wrap content with a stopPropagation */}
                        <div
                          onClick={(e) => e.stopPropagation()}
                          onMouseDown={(e) => e.stopPropagation()} // also block submenu toggling
                        >
                          {CrmSettingsMenu}
                        </div>
                      </Modal>
                    </div>
                  }
                >
                  {CrmSubmenu.children.map((child) => (
                    <Menu.Item
                      key={child.key}
                      icon={React.cloneElement(child.icon, {
                        style: { fontSize: "16px" },
                      })}
                      onClick={() => {
                        navigate(child.link);
                        handleCrmMenuClick(child.key); // persist selection
                      }}
                    >
                      <Link
                        to={child.link}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {child.text}
                      </Link>
                    </Menu.Item>
                  ))}
                </SubMenu>
              )}

              {AnalyticsMenu && (
                <SubMenu
                  key={AnalyticsMenu.key}
                  icon={React.cloneElement(AnalyticsMenu.icon, {
                    style: {
                      fontSize:
                        collapsed && hoverEffectActive ? "20px" : "16px",
                    },
                  })}
                  title={AnalyticsMenu.text}
                >
                  {AnalyticsMenu.children.map((child) => (
                    <Menu.Item
                      key={child.key}
                      icon={React.cloneElement(child.icon, {
                        style: { fontSize: "16px" },
                      })}
                      onClick={() => {
                        (navigate(child.link), handleMenuItemClick(child.key));
                      }}
                    >
                      <Link
                        to={child.link}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {child.text}
                      </Link>
                    </Menu.Item>
                  ))}
                </SubMenu>
              )}
              {AccountingMenu && (
                <SubMenu
                  key={AccountingMenu.key}
                  icon={React.cloneElement(AccountingMenu.icon, {
                    style: {
                      fontSize:
                        collapsed && hoverEffectActive ? "20px" : "16px",
                    },
                  })}
                  title={AccountingMenu.text}
                >
                  {AccountingMenu.children.map((child) => (
                    <Menu.Item
                      key={child.key}
                      icon={React.cloneElement(child.icon, {
                        style: { fontSize: "16px" },
                      })}
                      onClick={() => {
                        (navigate(child.link), handleMenuItemClick(child.key));
                      }}
                    >
                      <Link
                        to={child.link}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {child.text}
                      </Link>
                    </Menu.Item>
                  ))}
                </SubMenu>
              )}
                            {AmcItem && (
                <Menu.Item
                  key={AmcItem.key}
                  icon={
                    <span style={{ fontSize: "30px" }}>{AmcItem.icon}</span>
                  }
                  onClick={() => {
                    navigate(AmcItem.link);
                    onItemClick();
                    if (isSmallScreen) setCollapsed(true);
                  }}
                >
                  <Link
                    to={AmcItem.link}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {AmcItem.text}
                  </Link>
                </Menu.Item>
              )}
              {CalendarItem && (
                <Menu.Item
                  key={CalendarItem.key}
                  icon={
                    <span style={{ fontSize: "30px" }}>
                      {CalendarItem.icon}
                    </span>
                  }
                  onClick={() => {
                    navigate(CalendarItem.link);
                    onItemClick();
                    if (isSmallScreen) setCollapsed(true);
                  }}
                >
                  <Link
                    to={CalendarItem.link}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {CalendarItem.text}
                  </Link>
                </Menu.Item>
              )}
              {ReportItem && (
                <Menu.Item
                  key={ReportItem.key}
                  icon={React.cloneElement(ReportItem.icon, {
                    style: {
                      fontSize:
                        collapsed && hoverEffectActive ? "20px" : "16px",
                    },
                  })}
                  onClick={() => {
                    (navigate(ReportItem.link),
                      handleMenuItemClick(ReportItem.key));
                  }}
                >
                  <Link
                    to={ReportItem.link}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {ReportItem.text}
                  </Link>
                </Menu.Item>
              )}
              {rolesPermissionItem && (
                <Menu.Item
                  key={rolesPermissionItem.key}
                  icon={
                    <span style={{ fontSize: "30px" }}>
                      {rolesPermissionItem.icon}
                    </span>
                  }
                  onClick={() => {
                    navigate(rolesPermissionItem.link); // Changed from item.link to rolesPermissionItem.link
                    onItemClick();

                    if (isSmallScreen) setCollapsed(true);
                  }}
                >
                  <Link
                    to={rolesPermissionItem.link}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {rolesPermissionItem.text}
                  </Link>
                </Menu.Item>
              )}
              {settingsItem && (
                <Menu.Item
                  key={settingsItem.key}
                  icon={
                    <span style={{ fontSize: "30px" }}>
                      {settingsItem.icon}
                    </span>
                  }
                  onClick={() => {
                    navigate(settingsItem.link); // Changed from item.link to rolesPermissionItem.link
                    onItemClick();

                    if (isSmallScreen) setCollapsed(true);
                  }}
                >
                  <Link
                    to={settingsItem.link}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {settingsItem.text}
                  </Link>
                </Menu.Item>
              )}

              {NotificationConfigurationItem && (
                <Menu.Item
                  key={NotificationConfigurationItem.key}
                  icon={
                    <span style={{ fontSize: "30px" }}>
                      {NotificationConfigurationItem.icon}
                    </span>
                  }
                  onClick={() => {
                    navigate(NotificationConfigurationItem.link);
                    handleMenuItemClick(NotificationConfigurationItem.key);
                    if (isSmallScreen) setCollapsed(true);
                  }}
                >
                  <Link
                    to={NotificationConfigurationItem.link}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {NotificationConfigurationItem.text}
                  </Link>
                </Menu.Item>
              )}

              {chatbotItem && (
                <Menu.Item
                  key={chatbotItem.key}
                  icon={React.cloneElement(chatbotItem.icon, {
                    style: { fontSize: "16px" },
                  })}
                  onClick={() => {
                    navigate(chatbotItem.link);
                    onItemClick();
                    if (isSmallScreen) setCollapsed(true);
                  }}
                >
                  <Link
                    to={chatbotItem.link}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {chatbotItem.text}
                  </Link>
                </Menu.Item>
              )}
            </Menu>
          </div>
        </Drawer>
      ) : (
        <Sider
          ref={siderRef}
          trigger={null}
          collapsible
          collapsed={collapsed}
          collapsedWidth={80}
          width={240}
          // onMouseEnter={handleMouseEnter}
          // onMouseLeave={handleMouseLeave}
          style={{
            position: "fixed",
            height: "100vh",
            zIndex: 1000,
            overflow: "hidden",
          }}
        >
          <div style={{ position: "relative", height: "100vh", display: "flex", flexDirection: "column", backgroundColor: "#001529" }}>
            {/* Logo */}
            <div
              style={{
                textAlign: "center",
                backgroundColor: "#001529",
                padding: "10px 0",
                display: "flex",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <img
                src={settings ? settings.logo : Logo_Main}
                alt="logo"
                style={{
                  maxHeight: "70px",
                  transition: "all 0.2s",
                  width: collapsed ? "60px" : "auto",
                }}
              />
            </div>

            {/* Scrollable menu area */}
            <div
              style={{
                flex: 1,
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
            <Menu
              mode={collapsed ? "vertical" : "inline"}
              theme="dark"
              triggerSubMenuAction="hover" // 👈 makes submenu open on hover, not click
              selectedKeys={
                slug
                  ? (selectedKeys.filter(Boolean) as string[])
                  : ([activeMenuItemKey].filter(Boolean) as string[])
              }
              openKeys={collapsed ? undefined : openKeys} // 👈 don’t keep open keys when collapsed
              onOpenChange={collapsed ? undefined : onOpenChange} // 👈 disable submenu toggle when collapsed
              style={{
                color: "white",
                width: "100%",
              }}
              forceSubMenuRender
            >
              {menuItems.map((item) => (
                <Menu.Item
                  key={item.key}
                  icon={React.cloneElement(item.icon, {
                    style: {
                      fontSize:
                        collapsed && hoverEffectActive ? "20px" : "16px",
                    },
                  })}
                  onClick={() => {
                    (navigate(item.link), handleMenuItemClick(item.key));
                  }}
                >
                  <Link
                    to={item.link}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {item.text}
                  </Link>
                </Menu.Item>
              ))}

              {masterSubmenu && (
                <SubMenu
                  key={masterSubmenu.key}
                  icon={React.cloneElement(masterSubmenu.icon, {
                    style: {
                      fontSize:
                        collapsed && hoverEffectActive ? "20px" : "16px",
                    },
                  })}
                  title={masterSubmenu.text}
                >
                  {masterSubmenu.children.map((child) => (
                    <Menu.Item
                      key={child.key}
                      icon={React.cloneElement(child.icon, {
                        style: { fontSize: "16px" },
                      })}
                      onClick={() => {
                        (navigate(child.link), handleMenuItemClick(child.key));
                      }}
                    >
                      <Link
                        to={child.link}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {child.text}
                      </Link>
                    </Menu.Item>
                  ))}
                </SubMenu>
              )}

              {attendanceSubmenu && (
                <SubMenu
                  key={attendanceSubmenu.key}
                  icon={React.cloneElement(attendanceSubmenu.icon, {
                    style: {
                      fontSize:
                        collapsed && hoverEffectActive ? "20px" : "16px",
                    },
                  })}
                  title={attendanceSubmenu.text}
                >
                  {attendanceSubmenu.children.map((child) => (
                    <Menu.Item
                      key={child.key}
                      icon={React.cloneElement(child.icon, {
                        style: { fontSize: "16px" },
                      })}
                      onClick={() => {
                        (navigate(child.link), handleMenuItemClick(child.key));
                      }}
                    >
                      <Link
                        to={child.link}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {child.text}
                      </Link>
                    </Menu.Item>
                  ))}
                </SubMenu>
              )}

              {CrmSubmenu && (
                <SubMenu
                  key={CrmSubmenu.key}
                  popupClassName="crm-submenu-popup"
                  icon={React.cloneElement(CrmSubmenu.icon, {
                    style: {
                      fontSize:
                        collapsed && hoverEffectActive ? "20px" : "16px",
                    },
                  })}
                  title={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      CRM
                      <Tooltip title="CRM Settings">
                        <Button
                          type="text"
                          style={{ color: "white" }}
                          size="small"
                          icon={<SettingOutlined />}
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsCrmSettingsOpen(true); // open modal
                          }}
                        />
                      </Tooltip>
                      <Modal
                        destroyOnClose
                        style={{
                          bottom: 20,
                          top: 20,
                          // maxHeight: 'calc(100vh - 30px)',
                          margin: "0 auto",
                          position: "relative",
                        }}
                        styles={{
                          body: {
                            overflowY: "auto",
                            fontFamily: "inter, sans-serif",
                          },
                          header: {
                            padding: "12px",
                            position: "sticky",
                            top: 0,
                            backgroundColor: "#f1f5ffff",
                          },
                          content: {
                            padding: 0,
                            overflow: "hidden",
                          },
                        }}
                        title={
                          <div
                            style={{
                              color: "#4b5563",
                              fontFamily: "inter, sans-serif",
                              fontSize: "20px",
                              fontWeight: 500,
                            }}
                          >
                            CRM Favourite Filter
                          </div>
                        }
                        open={isCrmSettingsOpen}
                        onCancel={(e) => {
                          e.stopPropagation();
                          resetCrmSettings(); // ✅ clear all values
                          setIsCrmSettingsOpen(false);
                        }}
                        footer={null}
                        width={650}
                      >
                        {/* 🛑 wrap content with a stopPropagation */}
                        <div
                          onClick={(e) => e.stopPropagation()}
                          onMouseDown={(e) => e.stopPropagation()} // also block submenu toggling
                        >
                          {CrmSettingsMenu}
                        </div>
                      </Modal>
                    </div>
                  }
                >
                  {CrmSubmenu.children.map((child) => (
                    <Menu.Item
                      key={child.key}
                      icon={React.cloneElement(child.icon, {
                        style: { fontSize: "16px" },
                      })}
                      onClick={() => {
                        navigate(child.link);
                        setSelectedKeys([child.key]); // ⚡ only this submenu selected
                        setOpenKeys(["crm"]);
                      }}
                    >
                      <Link
                        to={child.link}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {child.text}
                      </Link>
                    </Menu.Item>
                  ))}

                  {/* <Menu
                    mode="inline"
                    selectable={false}
                    style={{ backgroundColor: "inherit" }}
                  >
                    {favouriteFilters.map((f: any) => {
                      const IconComp = (Icons as any)[f.icon];
                      return (
                        <Menu.Item
                          icon={IconComp && <IconComp style={{ fontSize: "16px" }} />}
                          onClick={() => {
                            applyFavouriteFilter(f);
                          }}
                        >

                          <span
                            style={{
                              flex: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {f.name}
                          </span>

                        </Menu.Item>
                      );
                    })}
                  </Menu> */}
                </SubMenu>
              )}

              {AnalyticsMenu && (
                <SubMenu
                  key={AnalyticsMenu.key}
                  icon={React.cloneElement(AnalyticsMenu.icon, {
                    style: {
                      fontSize:
                        collapsed && hoverEffectActive ? "20px" : "16px",
                    },
                  })}
                  title={AnalyticsMenu.text}
                >
                  {AnalyticsMenu.children.map((child) => (
                    <Menu.Item
                      key={child.key}
                      icon={React.cloneElement(child.icon, {
                        style: { fontSize: "16px" },
                      })}
                      onClick={() => {
                        (navigate(child.link), handleMenuItemClick(child.key));
                      }}
                    >
                      <Link
                        to={child.link}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {child.text}
                      </Link>
                    </Menu.Item>
                  ))}
                </SubMenu>
              )}

              {AccountingMenu && (
                <SubMenu
                  key={AccountingMenu.key}
                  icon={React.cloneElement(AccountingMenu.icon, {
                    style: {
                      fontSize:
                        collapsed && hoverEffectActive ? "20px" : "16px",
                    },
                  })}
                  title={AccountingMenu.text}
                >
                  {AccountingMenu.children.map((child) => (
                    <Menu.Item
                      key={child.key}
                      icon={React.cloneElement(child.icon, {
                        style: { fontSize: "16px" },
                      })}
                      onClick={() => {
                        (navigate(child.link), handleMenuItemClick(child.key));
                      }}
                    >
                      <Link
                        to={child.link}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {child.text}
                      </Link>
                    </Menu.Item>
                  ))}
                </SubMenu>
              )}

              {AmcItem && (
                <Menu.Item
                  key={AmcItem.key}
                  icon={React.cloneElement(AmcItem.icon, {
                    style: {
                      fontSize:
                        collapsed && hoverEffectActive ? "20px" : "16px",
                    },
                  })}
                  onClick={() => {
                    (navigate(AmcItem.link), handleMenuItemClick(AmcItem.key));
                  }}
                >
                  <Link
                    to={AmcItem.link}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {AmcItem.text}
                  </Link>
                </Menu.Item>
              )}
              {CalendarItem && (
                <Menu.Item
                  key={CalendarItem.key}
                  icon={React.cloneElement(CalendarItem.icon, {
                    style: {
                      fontSize:
                        collapsed && hoverEffectActive ? "20px" : "16px",
                    },
                  })}
                  onClick={() => {
                    (navigate(CalendarItem.link),
                      handleMenuItemClick(CalendarItem.key));
                  }}
                >
                  <Link
                    to={CalendarItem.link}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {CalendarItem.text}
                  </Link>
                </Menu.Item>
              )}

              {ReportItem && (
                <Menu.Item
                  key={ReportItem.key}
                  icon={React.cloneElement(ReportItem.icon, {
                    style: {
                      fontSize:
                        collapsed && hoverEffectActive ? "20px" : "16px",
                    },
                  })}
                  onClick={() => {
                    (navigate(ReportItem.link),
                      handleMenuItemClick(ReportItem.key));
                  }}
                >
                  <Link
                    to={ReportItem.link}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {ReportItem.text}
                  </Link>
                </Menu.Item>
              )}
              
              {NotificationConfigurationItem && (
                <Menu.Item
                  key={NotificationConfigurationItem.key}
                  icon={React.cloneElement(NotificationConfigurationItem.icon, {
                    style: {
                      fontSize:
                        collapsed && hoverEffectActive ? "20px" : "16px",
                    },
                  })}
                  onClick={() => {
                    navigate(NotificationConfigurationItem.link);
                    handleMenuItemClick(NotificationConfigurationItem.key);
                  }}
                >
                  <Link
                    to={NotificationConfigurationItem.link}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {NotificationConfigurationItem.text}
                  </Link>
                </Menu.Item>
              )}

              {chatbotItem && (
                <Menu.Item
                  key={chatbotItem.key}
                  icon={React.cloneElement(chatbotItem.icon, {
                    style: {
                      fontSize:
                        collapsed && hoverEffectActive ? "20px" : "16px",
                    },
                  })}
                  onClick={() => {
                    navigate(chatbotItem.link);
                    handleMenuItemClick(chatbotItem.key);
                  }}
                >
                  <Link
                    to={chatbotItem.link}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {chatbotItem.text}
                  </Link>
                </Menu.Item>
              )}
            </Menu>
          </div>

          {/* Fixed profile footer - like ChatGPT */}
          <div
            className="profile-footer-area"
            style={{
              flexShrink: 0,
              borderTop: "1px solid rgba(255,255,255,0.1)",
              backgroundColor: "#001529",
              position: "relative",
            }}
          >
            {/* Popup menu - opens upward with smooth animation */}
            <div
              style={{
                position: "absolute",
                bottom: "56px",
                left: "8px",
                right: "8px",
                backgroundColor: "#fff",
                borderRadius: "10px",
                boxShadow: "0 -4px 20px rgba(0,0,0,0.15)",
                overflow: "hidden",
                zIndex: 1001,
                transformOrigin: "bottom center",
                transform: profileMenuOpen && !collapsed ? "scaleY(1)" : "scaleY(0)",
                opacity: profileMenuOpen && !collapsed ? 1 : 0,
                transition: "transform 0.2s ease, opacity 0.2s ease",
                pointerEvents: profileMenuOpen && !collapsed ? "auto" : "none",
              }}
            >
              <div
                onClick={() => { navigate("/profile"); setProfileMenuOpen(false); }}
                style={{ padding: "10px 16px", cursor: "pointer", display: "flex", alignItems: "center", gap: "10px", color: "#374151", fontSize: "14px" }}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#f3f4f6")}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = "transparent")}
              >
                <UserOutlined style={{ fontSize: "15px" }} />
                Profile
              </div>
              {(isAdmin || hasPermission("roles") || hasPermission("permissions")) && (
                <div
                  onClick={() => { navigate("/roles"); setProfileMenuOpen(false); }}
                  style={{ padding: "10px 16px", cursor: "pointer", display: "flex", alignItems: "center", gap: "10px", color: "#374151", fontSize: "14px" }}
                  onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#f3f4f6")}
                  onMouseLeave={e => (e.currentTarget.style.backgroundColor = "transparent")}
                >
                  <SafetyOutlined style={{ fontSize: "15px" }} />
                  Roles & Permission
                </div>
              )}
              {(isAdmin || hasPermission("settings")) && (
                <div
                  onClick={() => { navigate("/settings"); setProfileMenuOpen(false); }}
                  style={{ padding: "10px 16px", cursor: "pointer", display: "flex", alignItems: "center", gap: "10px", color: "#374151", fontSize: "14px" }}
                  onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#f3f4f6")}
                  onMouseLeave={e => (e.currentTarget.style.backgroundColor = "transparent")}
                >
                  <SettingOutlined style={{ fontSize: "15px" }} />
                  Settings
                </div>
              )}
              <div style={{ height: "1px", backgroundColor: "#e5e7eb", margin: "0 8px" }} />
              <div
                onClick={() => { handleLogout(); setProfileMenuOpen(false); }}
                style={{ padding: "10px 16px", cursor: "pointer", display: "flex", alignItems: "center", gap: "10px", color: "#ef4444", fontSize: "14px" }}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#fef2f2")}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = "transparent")}
              >
                <LogoutOutlined style={{ fontSize: "15px", color: "#ef4444" }} />
                Log out
              </div>
            </div>

            {/* Profile button */}
            <div
              onClick={() => setProfileMenuOpen(prev => !prev)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: collapsed ? "12px 0" : "10px 16px",
                cursor: "pointer",
                justifyContent: collapsed ? "center" : "flex-start",
                height: "56px",
              }}
              onMouseEnter={e => (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.08)")}
              onMouseLeave={e => (e.currentTarget.style.backgroundColor = "transparent")}
            >
              {(() => {
                const userPhoto = authData?.user?.photo;
                const avatarSrc = userPhoto && typeof userPhoto === "string" && userPhoto.trim() !== ""
                  ? userPhoto.startsWith("http")
                    ? userPhoto
                    : `${process.env.REACT_APP_IMAGE_URL}/developers/${userPhoto}`
                  : process.env.PUBLIC_URL + "/download.png";
                return (
                  <img
                    src={avatarSrc}
                    alt="profile"
                    style={{
                      width: "32px", height: "32px", borderRadius: "50%",
                      objectFit: "cover", flexShrink: 0,
                      border: "2px solid rgba(255,255,255,0.3)",
                    }}
                  />
                );
              })()}
              {!collapsed && (
                <>
                  <div style={{ overflow: "hidden", flex: 1 }}>
                    <div style={{ color: "#fff", fontSize: "13px", fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {authData?.user?.username || authData?.user?.name || "User"}
                    </div>
                    <div style={{ color: "rgba(255,255,255,0.5)", fontSize: "11px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {authData?.user?.email || ""}
                    </div>
                  </div>
                  <svg
                    width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="rgba(255,255,255,0.6)" strokeWidth="2.5"
                    strokeLinecap="round" strokeLinejoin="round"
                    style={{
                      flexShrink: 0,
                      transform: profileMenuOpen ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.2s ease",
                    }}
                  >
                    <polyline points="18 15 12 9 6 15" />
                  </svg>
                </>
              )}
            </div>
          </div>
          </div>
        </Sider>
      )}
    </>
  );
};

export default Sidebar;
